import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var GraduationCapIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M21.11,9.07l-8.22,2.55a2,2,0,0,1-1.78,0L2.89,9.07a.51.51,0,0,1,0-.9l8.22-2.55a2,2,0,0,1,1.78,0l8.22,2.55A.51.51,0,0,1,21.11,9.07Z",
    stroke: "#000",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/_jsx("path", {
    d: "M13.62,13.49a4,4,0,0,1-3.24,0L4.79,11.73v5.63a1,1,0,0,0,.54.84l5.15,1.57h0A2.52,2.52,0,0,0,11.6,20h.05a2.52,2.52,0,0,0,1.13-.26h0l5.15-1.57a1,1,0,0,0,.54-.84V12Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M3.56,15.89a.5.5,0,0,1-.5-.5V9.09a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v6.3A.5.5,0,0,1,3.56,15.89Z"
  })]
}), 'GraduationCapIcon');